module.exports = __webpack_public_path__ + "img/fa-search.2cfd2697.svg";